import Tracks from './tracks'

export default Tracks
